<div class="custom-section-title mt-16px">
  {{header}}
</div>
<div *ngIf="subheader"
     class="change-password-subheader">
  {{subheader}}
</div>
<hr class="mt-28px mb-24px">
